// extracted by mini-css-extract-plugin
export var acceptedTCHeaderWrapper = "components-account-panels-__TermsAndConditions-module___acceptedTCHeaderWrapper";
export var acceptedTCWrapper = "components-account-panels-__TermsAndConditions-module___acceptedTCWrapper";
export var tcDate = "components-account-panels-__TermsAndConditions-module___tcDate";
export var tcName = "components-account-panels-__TermsAndConditions-module___tcName";